import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";

export class ServicePropositionMap {
    public static getString(ServiceProposition: ServiceProposition): string {
        return this.getMap().get(ServiceProposition);
    }

    public static getEnum(ServiceProposition: string): ServiceProposition {
        const map = this.getMap();

        let result: ServiceProposition;

        map.forEach((value: string, index: ServiceProposition) => {
            if (value === ServiceProposition) {
                result = index;
            }
        });

        return result;
    }

    public static getArray(): ServiceProposition[] {
        const options = [ServiceProposition.Wrap, ServiceProposition.Fundzone];
        return options;
    }

    private static getMap(): Map<ServiceProposition, string> {
        const map = new Map<ServiceProposition, string>();
        map.set(ServiceProposition.Wrap, "Wrap");
        map.set(ServiceProposition.Fundzone, "Fundzone");
        map.set(ServiceProposition.NonWrapEnabled, "Non Wrap Enabled");
        return map;
    }
}
